import WorkspacesIcon from '@mui/icons-material/Workspaces';
import ControlList from './ControlList';

export default {
  list: ControlList,
  icon: WorkspacesIcon,
  recordRepresentation: (record: any) => `${record.id}`,
};
